import RefreshIcon from "@/assets/refresh.svg";
import { useState } from "react";

interface IProps {
  d: number;
  h: number;
  m: number;
  totalDays: number;
  start: string;
  end: string;
  unstakingAmount: number;
  onRefresh: () => Promise<void>;
}

const CooldownPeriod = ({
  d,
  h,
  m,
  totalDays,
  start,
  end,
  unstakingAmount,
  onRefresh,
}: IProps) => {
  // const [timeRemaining, setTimeRemaining] = useState({ d, h, m });

  const [isRefreshing, setIsRefreshing] = useState(false);
  // const timerRef = useRef<NodeJS.Timeout | null>(null);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setTimeRemaining((prev) => {
  //       const { d, h, m } = prev;
  //       const newTime = { d, h, m };
  //       newTime.m -= 1;
  //       if (newTime.m < 0) {
  //         newTime.m = 59;
  //         newTime.h -= 1;
  //       }
  //       if (newTime.h < 0) {
  //         newTime.m = 59;
  //         newTime.h = 23;
  //         newTime.d -= 1;
  //       }
  //       return {
  //         d: Math.max(newTime.d, 0),
  //         h: Math.max(newTime.h, 0),
  //         m: Math.max(newTime.m, 0),
  //       };
  //     });
  //   }, 60000);
  //   timerRef.current = interval;

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, []);

  // const progress =
  //   100 -
  //   ((timeRemaining.d * 24 * 60 + timeRemaining.h * 60 + timeRemaining.m) *
  //     100) /
  //     (totalDays * 24 * 60);

  const refresh = async () => {
    setIsRefreshing(true);
    await onRefresh();
    setIsRefreshing(false);
  };

  const progress =
    100 - ((d * 24 * 60 + h * 60 + m) * 100) / (totalDays * 24 * 60);

  return (
    <div className="relative p-4 bg-[#eaa13b] bg-opacity-[0.12] flex flex-col gap-2 font-inter text-xl text-center border border-[#eaa13b1f]">
      <RefreshIcon
        onClick={refresh}
        className={`cursor-pointer absolute top-4 right-4 w-6 h-6 ${
          isRefreshing ? "animate-spin" : ""
        }`}
      />
      <div className="flex flex-col gap-1">
        <div className="text-warning font-semibold">COOLDOWN PERIOD ACTIVE</div>
        <div className="text-white">Your unstaked tokens are locked for</div>
      </div>
      {/* <div className="font-semibold text-2xl py-3">
        {timeRemaining.d} DAYS : {timeRemaining.h} HOURS : {timeRemaining.m}{" "}
        MINUTES{" "}
      </div> */}
      <div className="font-semibold text-2xl py-3">
        {d} DAYS : {h} HOURS : {m} MINUTES{" "}
      </div>
      <div className="bg-white bg-opacity-[0.08] w-full h-1 rounded-full">
        <div
          className="h-1 bg-warning rounded-full"
          style={{
            width: progress + "%",
          }}
        ></div>
      </div>
      <div className="flex justify-between items-center">
        <div className="flex flex-col items-start">
          {!!start && (
            <>
              <div className="text-sm leading-5 text-[#747481]">Started</div>
              <div>{start}</div>
            </>
          )}
        </div>

        <div className="flex flex-col items-end">
          {!!end && (
            <>
              <div className="text-sm leading-5 text-[#747481]">End</div>
              <div>{end}</div>
            </>
          )}
        </div>
      </div>
      <div className="h-[1px] bg-white bg-opacity-10 w-full"></div>
      <div className="w-full text-left">
        <span className="font-medium text-sm">Amount unstaking: </span>
        <span className="text-sm font-semibold">{unstakingAmount} SPON</span>
      </div>
    </div>
  );
};

export default CooldownPeriod;
